// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__VD1GP","choiceBoxes":"toolbarselects_choiceBoxes__1nVxS","simpleField":"toolbarselects_simpleField__12Zsi"};